import { Node } from "@tiptap/core";

export default Node.create({
  name: "text",
  group: "inline",
});
